import store from '../store';

export default class OperateDom {
    constructor(){

    }
    static getStyle(el,imgUrl){
        el.style.background = 'url('+ imgUrl +') no-repeat'
    }
    // transition: All .3s ease-in-out;
    static setTransition(el,index,opacity,transform){
        if(index == 'none'){
            el.style.opacity = opacity;
            el.style.transition = 'All .3s ease-in-out';
            el.style.transform = transform;
            return;
        }
        el[index].style.opacity = opacity;
        el[index].style.transition = 'All .3s ease-in-out';
        el[index].style.transform = transform;
    }
}


// WEBPACK FOOTER //
// ./src/manager/OperateDom.js